export type DevicePlatform = 'ios' | 'android' | 'other';

/**
 * Classify the current browser as iOS, Android, or other from the user agent.
 * Does not treat a narrow desktop viewport as mobile.
 */
export const getDevicePlatform = (
  userAgent: string = typeof navigator !== 'undefined'
    ? navigator.userAgent
    : '',
): DevicePlatform => {
  if (/android/i.test(userAgent)) {
    return 'android';
  }

  const isIosDevice = /iPhone|iPad|iPod/i.test(userAgent);
  const isIpadOs =
    /Macintosh/i.test(userAgent) &&
    typeof navigator !== 'undefined' &&
    Number(navigator.maxTouchPoints) > 1;

  if (isIosDevice || isIpadOs) {
    return 'ios';
  }

  return 'other';
};
